import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT, Environment, Namespace } from '@netfoundry-ui/shared/model';
import { result, toLower } from 'lodash';
import { catchError, delay } from 'rxjs/operators';
import { throwError as observableThrowError } from 'rxjs/internal/observable/throwError';
import {
    GetOption,
    HateoasResourceOperation,
    HttpMethod,
    PagedGetOption,
    PagedResourceCollection,
} from '@lagoshny/ngx-hateoas-client';
import { take, tap } from 'rxjs/operators';
import { HTTP_CLIENT, TokenService } from './token.service';
import { LoggerService } from './logger.service';


@Injectable({ providedIn: 'root' })
export class NamespaceService extends HateoasResourceOperation<Namespace> {
    apiUrl;
    appsUrl;
    networkPricing = 199.0;
    regionPricing = [{ region: null, price: 0.2, rate: 'GB' }];
    lastPageCount = 0;
    lastTotalCount = 0;
    static defaultHttpAccept = {
        headers: { accept: 'application/hal+json' },
        pageParams: {
            page: 0,
            size: 2000,
        },
    };

    constructor(
        private logger: LoggerService,
        private tokenService: TokenService,
        @Inject(HTTP_CLIENT) private http: HttpClient,
        @Inject(ENVIRONMENT) private environment: Environment
    ) {
        super(Namespace);
        this.apiUrl = this.environment.frontdoorURL;
    }


        public getNamespaces(id: string, options?: PagedGetOption): Promise<Namespace[]> {
              const headers = new HttpHeaders().set('Accept', 'application/hal+json');
            
              let params = new HttpParams().set('sort', 'createdAt,DESC');
            if(options) {
        if (options.pageParams) {
          Object.keys(options.pageParams).forEach(key => {
            const value = options.pageParams[key]; // <-- Corrected
            if (value !== undefined && value !== null) {
              params = params.append(key, String(value));
            }
          });
        }
    
       // Handle the nested params object
        if (options.params) {
          Object.keys(options.params).forEach(key => {
            const value = options.params[key]; // <-- Corrected
            if (value !== undefined && value !== null) {
              params = params.append(key, String(value));
            }
          });
        
      }
    }
            return this.http
                    .get<any>(`${this.apiUrl}/v2/${id}/namespaces`, {
                        headers,
                        params,
                        })
                .pipe(
                    tap((val) => {
                        this.lastPageCount = val.page.totalPages;
                        this.lastTotalCount = val.page.totalElements;
                    })
                )
                .toPromise()
        }


    public getSingleNamespace(id, namespaceId) {
        const fullpath = `${this.apiUrl}/v2/${id}/namespaces/${namespaceId}`
        return this.http
            .get(fullpath, {
    headers: { Accept: 'application/hal+json' }})
    }


    public create(model, id) {
        const fullpath = `${this.apiUrl}/v2/${id}/namespaces`;
            return this.http
                .post(fullpath, model, )
    }

    public getDNSRecords(id, token) {
        const fullpath = `${this.apiUrl}/v2/${id}/namespaces/${token}/dns-records`;
            return this.http
                .get(fullpath, {
                   headers: { Accept: 'application/hal+json' } 
            } )
    }

    public update(model, id, namespaceId) {
        const fullpath = `${this.apiUrl}/v2/${id}/namespaces/${namespaceId}`;
            return this.http
            .patch(fullpath, model)
    }

        public delete(frontdoorId: string, id: string) {
        const headers = this.setHeaders();
        const fullpath = `${this.apiUrl}/v2/${frontdoorId}/namespaces/${id}`;
            return this.http
                .delete(fullpath, {headers: headers})
    }


    /**
     * @param path
     * @param data
     */
    public post(path: string, data) {
        const fullpath = `${this.apiUrl}${path}`;
        const body = data;

        return this.http.post(fullpath, JSON.stringify(body), { headers: this.setHeaders() });
    }

    /**
     * @param path
     * @param data
     */
    public put(path: string, data) {
        const fullpath = `${this.apiUrl}${path}`;
        const body = data;

        return this.http.put(fullpath, JSON.stringify(body), { headers: this.setHeaders() });
    }

    /**
     * Generic GETter
     */

    public get(path: string) {
        const fullpath = `${this.apiUrl}${path}`;

        return this.http.get(fullpath, { headers: this.setHeaders() });
    }

    /**
     * Return headers
     */
    private setHeaders(): HttpHeaders {
        const headers = new HttpHeaders();

                  return headers.append('Content-Type', 'application/json');
    }

        /**
     * Generic error handler for bad requests
     */
        protected handleError(scope: any, error: HttpErrorResponse) {
            if (error.error instanceof ErrorEvent) {
                // A client-side or network error occurred. Handle it accordingly.
                scope.logger.error('Feature Service error occurred:', error.error);
            } else {
                // The backend returned an unsuccessful response code.
                // The response body may contain clues as to what went wrong,
                scope.logger.error(`Feature Backend returned code ${error.status}`, error.error);
            }
            scope.lastErrorSource.next(error);
            return observableThrowError(error);
        }
}
